import paths from "~/constants/paths";
import useCart from "~/composables/checkout/useCart";

export default defineNuxtRouteMiddleware(() => {
  const { isCartEmpty } = useCart();

  if (isCartEmpty.value) {
    return navigateTo(paths.cart);
  }
});
